module.exports = __webpack_public_path__ + "static/condo_entire_page-c2a2ca9a44a479896c79ee7783bd01a2.jpg";